module.exports = __webpack_public_path__ + "static/media/bell-slash.b4205509.svg";